import { Link } from "react-router-dom";

const BeardedVultureImg = "/Images/Vulture.jpg";

const BeardedVulture = () => {
  return (
    <>
      {/* ── HERO ── */}
      <section
        style={{
          height: "100vh",
          position: "relative",
          backgroundImage: `url(${BeardedVultureImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,.12), rgba(0,0,0,.48))",
          }}
        />

        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            alignItems: "center",
            padding: "0 48px",
          }}
        >
          <div style={{ maxWidth: "680px", color: "#fff", marginTop: "64px" }}>

            {/* breadcrumb + badge */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <span
                style={{
                  fontSize: "12px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 600,
                  letterSpacing: "1px",
                  cursor: "pointer",
                }}
              >
                ← All Species
              </span>
              <span
                style={{
                  background: "#dc3545",
                  color: "#fff",
                  fontSize: "9px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  padding: "4px 10px",
                }}
              >
                NEARLY THREATENED
              </span>
            </div>

            {/* heading */}
            <h1
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontSize: "clamp(3.5rem, 7vw, 5.2rem)",
                fontWeight: 400,
                lineHeight: 0.92,
                margin: "0 0 20px 0",
                letterSpacing: "-0.5px",
              }}
            >
              Bearded
              <br />
              Vulture
            </h1>

            {/* scientific name */}
            <p
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontStyle: "italic",
                fontSize: "17px",
                color: "rgba(255,255,255,.85)",
                margin: "0 0 20px 0",
              }}
            >
              Gypaetus barbatus · Mountain cliffs & alpine zones · Europe, Africa, Asia
            </p>

            <hr
              style={{
                borderColor: "rgba(255,255,255,.5)",
                margin: "0 0 24px 0",
                width: "520px",
                maxWidth: "100%",
              }}
            />

            {/* stats row */}
            <div style={{ display: "flex", gap: "48px" }}>
              {[
                { value: "368–408", label: "LEFT IN SOUTH AFRICA" },
                { value: "30%", label: "SHOW ABNORMAL LEAD LEVEL" },
                { value: "1913", label: "LAST ALPINE BIRD SHOT" },
              ].map((stat, i) => (
                <div key={i}>
                  <div
                    style={{
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "clamp(1.8rem, 3vw, 2.8rem)",
                      fontWeight: 400,
                      lineHeight: 1,
                      marginBottom: "6px",
                    }}
                  >
                    {stat.value}
                  </div>
                  <div
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "9px",
                      fontWeight: 600,
                      letterSpacing: "1.2px",
                      color: "rgba(255,255,255,.8)",
                      maxWidth: "120px",
                      lineHeight: 1.5,
                    }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* ── BODY ── */}
      <section style={{ background: "#f5f3ee", padding: "64px 0" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 24px" }}>
          <div style={{ display: "flex", gap: "48px" }}>

            {/* ── LEFT SIDEBAR ── */}
            <div style={{ width: "240px", flexShrink: 0 }}>

              <div
                style={{
                  background: "#ece9e2",
                  padding: "20px",
                  marginBottom: "24px",
                }}
              >
                <h6
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontSize: "15px",
                    fontWeight: 400,
                    margin: "0 0 8px 0",
                  }}
                >
                  Support This Work
                </h6>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    lineHeight: 1.7,
                    margin: "0 0 16px 0",
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  }}
                >
                  Field research, community programs, and habitat protection all depend on donations.
                </p>
                <Link to="/donate" style={{ textDecoration: "none" }}>
                  <button
                    style={{
                      width: "100%",
                      background: "#6d735d",
                      color: "#fff",
                      border: "none",
                      padding: "10px",
                      fontSize: "11px",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontWeight: 700,
                      letterSpacing: "1.5px",
                      cursor: "pointer",
                    }}
                  >
                    DONATE
                  </button>
                </Link>
              </div>

              <div
                style={{
                  fontSize: "10px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 600,
                  letterSpacing: "2px",
                  color: "#999",
                  textTransform: "uppercase",
                  marginBottom: "4px",
                }}
              >
                Related Articles
              </div>

              {[
                { to: "/southern-grounded-hornbill", label: "Southern Ground Hornbill →", status: "Vulnerable" },
                { to: "/pels-fishing-owl", label: "Pel's Fishing Owl →", status: "Endangered" },
                { to: "/cape-gannet", label: "Cape Gannet →", status: "Endangered" },
              ].map((item, i) => (
                <div key={i} style={{ borderTop: "1px solid #ddd", padding: "12px 0" }}>
                  <Link
                    to={item.to}
                    style={{
                      textDecoration: "none",
                      color: "#222",
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "14px",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    {item.label}
                  </Link>
                  <small
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "11px",
                      color: "#888",
                    }}
                  >
                    {item.status}
                  </small>
                </div>
              ))}
            </div>

            {/* ── MAIN CONTENT ── */}
            <div style={{ flex: 1, minWidth: 0 }}>

              {/* intro + quick stats */}
              <div style={{ display: "flex", gap: "40px", marginBottom: "40px", alignItems: "flex-start" }}>
                <div style={{ flex: "0 0 55%" }}>
                  <p
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13.5px",
                      lineHeight: 2,
                      color: "#555",
                      margin: 0,
                    }}
                  >
                    The Bearded Vulture — also known as the Lammergeier, or 'bone-breaker' — is
                    one of the most extraordinary birds on Earth. It is the only vertebrate known to
                    survive almost entirely on a diet of bones. Its rust-orange plumage comes not from genetics, but from deliberately bathing in iron-rich mud — a behavior unique
                    among birds. Once extinct across Western Europe, it is the subject of one of
                    conservation's most painstaking recovery stories.
                  </p>
                </div>

                <div
  style={{
    flex: 1,
    display: "flex",
    gap: "16px",
    justifyContent: "space-between",
    textAlign: "center",
  }}
>
  {[
    { value: "13.7 lb (6.21 kg)", label: "Average Weight" },
    { value: "19.3 in–26.2 in (49–66.5 cm)", label: "Average Height" },
    { value: "21 years in the wild, over 40 years in captivity", label: "Average Lifespan" },
  ].map((s, i) => (
    <div
      key={i}
      style={{
        flex: 1,
        minWidth: 0,
        padding: "0 8px",
      }}
    >
      <div
        style={{
          fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "17px",
          fontWeight: 600,
          marginBottom: "4px",
          lineHeight: 1.3,
        }}
      >
        {s.value}
      </div>

      <div
        style={{
           fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "14px",
          color: "#888",
        }}
      >
        {s.label}
      </div>
    </div>
  ))}
</div>
              </div>

              {/* personal note */}
              <div
                style={{
                  background: "#fff",
                  borderLeft: "3px solid #e0a320",
                  padding: "20px 24px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "1.5px",
                    color: "#c98d2c",
                    textTransform: "uppercase",
                    marginBottom: "12px",
                  }}
                >
                  A Personal Note
                </div>
                <p
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontStyle: "italic",
                    fontSize: "17px",
                    lineHeight: 1.6,
                    color: "#333",
                    margin: 0,
                  }}
                >
                  "What gets me about the Bearded Vulture is how strange and perfect it is — a bird that evolved an entirely unique ecological role. The idea of losing that is almost incomprehensible."
                </p>
              </div>

              {/* conservation status */}
              <div
                style={{
                  background: "#6d735d",
                  color: "#fff",
                  padding: "24px 28px",
                  marginBottom: "48px",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    marginBottom: "10px",
                    color: "rgba(255,255,255,.7)",
                  }}
                >
                  Conservation Status
                </div>
                <p
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "13.5px",
                    lineHeight: 1.85,
                    margin: 0,
                    color: "rgba(255,255,255,.92)",
                  }}
                >
                  The Bearded Vulture is classified as Near Threatened globally by the IUCN, with a decreasing population trend. In southern Africa, the population — confined entirely to the Maloti-Drakensberg Mountains of South Africa and Lesotho — is listed as Critically Endangered, with only 368 to 408 individuals remaining. In Europe, it is the rarest vulture species, wiped out from the Alps entirely by 1913.
                </p>
              </div>

              {/* why in trouble */}
              <h2
                style={{
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  fontSize: "28px",
                  fontWeight: 400,
                  margin: "0 0 32px 0",
                }}
              >
                Why This Species Is In Trouble
              </h2>

              <div style={{ position: "relative", marginBottom: "40px" }}>
                <div
                  style={{
                    position: "absolute",
                    left: "3px",
                    top: 0,
                    bottom: 0,
                    width: "1px",
                    background: "#ddd",
                  }}
                />

                {[
                  {
                    title: "Lead Poisoning",
                    text: "Bearded Vultures are bone specialists — they drop bones from great heights onto rocks to crack them open and access the marrow. When those bones come from animals shot with lead ammunition, the birds ingest lead fragments.",
                  },
                  {
                    title: "Poisoned Baits",
                    text: "Farmers set out poisoned baits targeting jackals, hyenas, and other perceived threats to livestock. Vultures drawn to carcasses are frequent, unintended victims. This is one of the most devastating threats to large raptors.",
                  },
                  {
                    title: "Power Line Collisions",
                    text: "With a wingspan approaching three meters, Bearded Vultures are particularly vulnerable to collisions with power lines and electrotraction on transmission infrastructure. Each death represents a decade or more of breeding potential.",
                  },
                  {
                    title: "Nest Disturbance",
                    text: "Human activity near cliff nest sites — hikers, climbers, photographers — can cause breeding failures. These birds are extraordinarily sensitive to disturbance during their long nesting season.",
                  },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", marginBottom: "36px" }}>
                    <div
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background: "#c98d2c",
                        flexShrink: 0,
                        marginTop: "6px",
                        marginRight: "20px",
                        position: "relative",
                        zIndex: 2,
                      }}
                    />
                    <div>
                      <h6
                        style={{
                          fontFamily: "Georgia, 'Times New Roman', serif",
                          fontSize: "15px",
                          fontWeight: 600,
                          margin: "0 0 6px 0",
                        }}
                      >
                        {item.title}
                      </h6>
                      <p
                        style={{
                          fontFamily: "'Helvetica Neue', Arial, sans-serif",
                          fontSize: "13px",
                          lineHeight: 1.85,
                          color: "#666",
                          margin: 0,
                        }}
                      >
                        {item.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* pull quote */}
              <div
                style={{
                  background: "#6d735d",
                  color: "#fff",
                  padding: "40px 44px",
                  margin: "0 0 48px 0",
                }}
              >
                <div
                  style={{
                    fontSize: "48px",
                    color: "#e0b04b",
                    lineHeight: 1,
                    marginBottom: "8px",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  "
                </div>
                <p
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontStyle: "italic",
                    fontSize: "22px",
                    lineHeight: 1.55,
                    margin: 0,
                  }}
                >
                  Two hundred years ago, Bearded Vultures soared over every mountain range in southern Europe. Today, fewer than 200 breeding pairs survive across the entire continent.
                </p>
              </div>

              {/* what we're doing */}
              <h2
                style={{
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  fontSize: "28px",
                  fontWeight: 400,
                  margin: "0 0 20px 0",
                }}
              >
                We're supporting the following activities
              </h2>

              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "48px" }}>
                {[
                  "Reintroduction programs in the Alps, Pyrenees, and southern Africa",
                  "Lead-free ammunition advocacy campaigns with hunting communities",
                  "Remote camera monitoring at known nest sites",
                  "Cross-border conservation partnerships in mountain regions",
                ].map((item, i) => (
                  <div
                    key={i}
                    style={{
                      background: "#fff",
                      border: "1px solid #e8e5df",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13.5px",
                      color: "#333",
                    }}
                  >
                    <span style={{ color: "#c98d2c", marginRight: "12px", fontSize: "16px" }}>○</span>
                    {item}
                  </div>
                ))}
              </div>

              {/* reasons for hope */}
              <div style={{ background: "#6d735d", padding: "28px 32px", color: "#fff" }}>
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,.7)",
                    marginBottom: "10px",
                  }}
                >
                  Reasons For Hope
                </div>
                <p
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "13.5px",
                    lineHeight: 1.85,
                    margin: "0 0 20px 0",
                    color: "rgba(255,255,255,.92)",
                  }}
                >
                  The Alpine reintroduction program has rebuilt a population from zero. The same rigorous,
                  patient approach is being applied in southern Africa — slowly, carefully, with real results.
                </p>
                <img
                  src="/Images/Vulture.png"
                  alt=""
                  style={{ width: "100%", display: "block" }}
                />
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BeardedVulture;